var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn blue center back-button",on:{"click":_vm.backClick}},[_c('font-awesome-icon',{attrs:{"icon":"arrow-left"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }